<template>
<svg viewBox="0 0 14 14" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-sync-msg`]" width="1em" height="1em" v-bind="$attrs"><path d="M4.86844 9.78451C5.68029 10.2748 6.69864 10.4493 7.66727 10.1953C7.54952 10.4088 7.48237 10.6541 7.48237 10.9154C7.48239 11.2278 7.57868 11.5176 7.74214 11.7578C6.46259 12.0163 5.19537 11.7587 4.11779 11.0853L3.10281 12.8444L1.58654 8.36914L5.99279 7.83854L4.86844 9.78451ZM12.3873 10.082C12.8475 10.0821 13.2207 10.4552 13.2207 10.9154C13.2206 11.3756 12.8475 11.7487 12.3873 11.7487H8.98237C8.52233 11.7485 8.14906 11.3755 8.14904 10.9154C8.14904 10.4553 8.52232 10.0822 8.98237 10.082H12.3873ZM12.3873 7.3737C12.8476 7.3737 13.2207 7.74679 13.2207 8.20703C13.2206 8.66719 12.8475 9.04037 12.3873 9.04037H10.0065C9.54643 9.0402 9.17323 8.66708 9.17313 8.20703C9.17313 7.7469 9.54637 7.37387 10.0065 7.3737H12.3873ZM12.0755 5.08073L7.56571 5.45898L8.6549 3.57227L8.48042 3.45312C7.58904 2.88606 6.39488 2.71871 5.2825 3.15234C3.68124 3.77661 2.78383 5.42676 3.04487 7.05925H1.49669C1.24582 4.80849 2.51639 2.58212 4.72391 1.72135C6.30186 1.10614 8.10171 1.37851 9.4329 2.22331L10.4557 0.453125L12.0755 5.08073Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillSyncMsg',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
